
import React from "react"
//import Image from "next/image"

interface FedRampBadgeProps {
  className?: string
  variant?: "default" | "subtle" | "minimal"
  animated?: boolean
}

export function FedRampBadge({ className = "", variant = "default", animated = false }: FedRampBadgeProps) {
  // Define styles based on variant
  const containerStyles = {
    default: "flex items-center py-3 px-5 bg-white rounded-lg border border-gray-100 shadow-sm group",
    subtle: "flex items-center py-2.5 px-4 bg-gray-50 rounded-lg border border-gray-100 group",
    minimal: "flex items-center py-2 px-3 rounded-md group",
  }

  const iconContainerStyles = {
    default: "mr-3 flex-shrink-0",
    subtle: "mr-2.5 flex-shrink-0",
    minimal: "mr-2 flex-shrink-0",
  }

  const iconSizes = {
    default: "w-8 h-8",
    subtle: "w-7 h-7",
    minimal: "w-5 h-5",
  }

  return (
    <div
      className={`${containerStyles[variant]} ${className} ${animated ? "transition-all duration-300 hover:shadow-md" : ""}`}
    >
      <div className={iconContainerStyles[variant]}>
        <div
          className={`relative ${iconSizes[variant]} ${animated ? "group-hover:scale-110 transition-transform duration-300" : ""} rounded-full overflow-hidden`}
        >
          <img src="https://assets.avepoint.com/upload/images/logos/fedramp-icon.png" alt="FedRAMP" className="object-contain" />
        </div>
      </div>
      <div className="flex flex-col">
        {(variant === "default" || variant === "subtle") && (
          <span className={`text-xs font-medium text-[#0A2559] ${variant === "subtle" ? "mb-0" : "mb-0.5"}`}>
            Federal Security Compliance
          </span>
        )}
        <p className={`${variant === "default" ? "text-sm" : "text-xs"} text-gray-700 font-medium`}>
          <span className="font-semibold">FedRAMP-Authorized</span> with DOD support for up to Impact Levels 5 and 6
        </p>
      </div>
    </div>
  )
}

export function FedRampBadgeWithTooltip({ className = "" }) {
  const [showTooltip, setShowTooltip] = React.useState(false)

  return (
    <div className="relative inline-block">
      <div
        className={`inline-flex items-center py-2.5 px-4 bg-white rounded-lg border border-gray-100 shadow-sm cursor-help ${className}`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <div className="mr-2.5 relative w-6 h-6 flex-shrink-0 rounded-full overflow-hidden">
          <img src="https://assets.avepoint.com/upload/images/logos/fedramp-icon.png" alt="FedRAMP" className="object-contain" />
        </div>
        <p className="text-sm text-gray-700 font-medium">
          <span className="font-semibold">FedRAMP-Authorized</span>
        </p>
      </div>

      {showTooltip && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 p-3 bg-[#0A2559] text-white text-xs rounded-lg shadow-lg z-10 animate-in fade-in duration-200">
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-[#0A2559]"></div>
          <p className="font-medium mb-1">Federal Risk and Authorization Management Program</p>
          <p className="text-gray-300 text-[11px] leading-tight">
            AvePoint solutions are FedRAMP-Authorized with DOD support for up to Impact Levels 5 and 6, ensuring the
            highest level of security compliance for organization agencies.
          </p>
        </div>
      )}
    </div>
  )
}
